module.exports = __webpack_public_path__ + "static/media/Daffodil-WIFI-Logo-Dark.3be3a4f7.png";